<!--
  name : (1차)장지향/(뷰티파이옮김)김혜진
  desc :
  date : 2021-01-11
-->
<template>
  <v-container id="main">
    <div id="wrap">
      <!-- //floating-->
      <div id="container">
        <header>
          <div class="header st99">
            <div class="header_wrap" :class="{ on: hidden }">
              <h1>
                <a href="/"><span class="logo_header">로고</span></a>
              </h1>
              <nav class="gnb">
                <h2 class="blind">메인 메뉴</h2>
                <!-- <div class="header_link">
							<h2 class="blind">로그인메뉴</h2>
							<ul>
								<li><a href="" class="icon_login">로그인</a></li>
								<li><a href="" class="icon_logout">회원가입</a></li>
							</ul>
						</div> -->
                <div class="mobile_btn">
                  <button class="menu" @click="toggle">리스트</button>
                </div>
                <ul class="menu_main" :class="{ on: hidden }">
                  <li class="menu menu_btn" @click="goPayment">요금제</li>
                  <li class="menu menu_btn" @click="goMain">
                    <a href="#goPMI">도입문의</a>
                  </li>
                  <li class="header_link">
                    <!--로그인 이동-->
                    <v-btn
                      class="btn_top_bar00"
                      @click="login"
                      v-if="!getName()"
                      >로그인</v-btn
                    >
                    <v-btn class="btn_top_bar00" @click="home" v-if="getName()"
                      >전자계약 홈</v-btn
                    >
                    <v-btn
                      class="btn_top_bar00"
                      @click="logout"
                      v-if="getName()"
                      >로그아웃</v-btn
                    >
                    <!--회원가입 이동-->
                    <v-btn
                      class="btn_top_bar00"
                      @click="goJoin"
                      v-if="!getName()"
                      >회원가입</v-btn
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
        <div class="header_overlay"></div>
        <v-row no-gutters id="content" class="main">
          <v-col cols="12" class="section_main main_img">
            <div class="content section_pay">
              <h3>요금제</h3>
              <p class="tit">건당 요금제</p>
              <p class="ct">*사용기한 1년 / 365일 이 후 잔여 건수 소멸</p>
              <div class="row no-gutters mb50">
                <div class="box1 tbl_pay">
                  <span>1건</span>
                  <strong>3,000</strong>
                  <p>단가 3,000</p>
                  <p class="sale">&nbsp;</p>
                </div>
                <div class="box2 tbl_pay">
                  <span>10건</span>
                  <strong>20,000</strong>
                  <p>단가 2,000</p>
                  <p class="sale">할인율 33%</p>
                </div>
                <div class="box3 tbl_pay">
                  <span>50건</span>
                  <strong>60,000</strong>
                  <p>단가 1,200</p>
                  <p class="sale">할인율 60%</p>
                </div>
                <div class="box4 tbl_pay">
                  <span>100건</span>
                  <strong>100,000</strong>
                  <p>단가 1,000</p>
                  <p class="sale">할인율 67%</p>
                </div>
                <div class="box5 tbl_pay">
                  <span>300건</span>
                  <strong>270,000</strong>
                  <p>단가 900</p>
                  <p class="sale">할인율 70%</p>
                </div>
              </div>
              <p class="txt">
                <span class="before"></span>계약 작성, 인증, 서명, 보관 등 모든
                기능이 포함된 가격입니다
              </p>
              <p class="txt2">※ 기업 회원 대상 요금제</p>
              <p class="txt2">
                ※ 300건 이상 사용 고객 및 연동 고객은 별도 협의 필요
              </p>
            </div>
          </v-col>
        </v-row>
        <footer>
          <div class="footer">
            <v-row no-gutters>
              <v-col cols="12" sm="3" md="3" lg="3"
                >(주)비즈니스온커뮤니케이션</v-col
              >
              <v-col cols="12" sm="5" md="5" lg="5"
                >06104 서울시 강남구 학동로 230 유빔빌딩</v-col
              >
              <v-col cols="12" sm="4" md="4" lg="4">고객센터 1588-8064</v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
              <v-col cols="12" sm="3" md="3" lg="3"
                >대표이사: 노태완</v-col
              >
              <v-col cols="12" sm="5" md="5" lg="5">
                <v-row no-gutters>
                  <v-col cols="12" sm="6" md="6" lg="6" class="nopd"
                    >사업자등록번호: 220-87-58882</v-col
                  >
                  <v-col cols="12" sm="6" md="6" lg="6" class="nopd"
                    >통신판매업: 서울강남-05259</v-col
                  >
                </v-row>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4"
                >개인정보 보호책임자: 곽상훈(privacy@businesson.co.kr)
              </v-col>
            </v-row>
            <div class="fmenu_wrap">
              <div class="fmenu">
                <ul>
                  <li v-on:click="userAgree" class="poinTer">이용약관</li>
                  <li v-on:click="personInfo" class="poinTer_2">
                    개인정보처리방침
                  </li>
                </ul>
              </div>
              <div class="copy">
                Copyright ⓒ BusinessOn Communication Co., Ltd. All rights
                reserved.
              </div>
            </div>
          </div>
        </footer>
        <s-confirm ref="confirm"></s-confirm>
        <s-loading ref="loading"></s-loading>
        <userAgreement ref="userAgreement"></userAgreement>
        <perInfoProtec ref="perInfoProtec"></perInfoProtec>
      </div>
    </div>
  </v-container>
</template>
<script>
import userAgreement from "@/components/userAgreement";
import perInfoProtec from "@/components/perInfoProtec";

export default {
  name: "mainPage",
  components: {
    userAgreement,
    perInfoProtec
  },
  filters: {},
  data() {
    return {
      svcForm: {
        Sum: "",
        Email: "",
        Phone: "",
        Cpn: "",
        Inq: "",
        ChkYN: false
      },
      // class 추가
      hidden: false
    };
  },
  created() {},
  mounted() {
    this.track();
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: "/index"
      });
    },
    // 모바일 버튼 토글
    toggle() {
      this.hidden = !this.hidden;
    },
    trackEvent() {
      this.$gtag.event("도입문의_클릭", {
        event_category: "글로싸인엔터프라이즈",
        event_label: "도입문의_클릭"
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    home() {
      this.$router.push({ name: "dashboard" });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push({ name: "main" });
        location.reload();
      });
    },
    getName() {
      this.userName = this.$store.state.user.username;
      if (
        this.$store.state.user.urtoken === undefined ||
        this.$store.state.user.urtoken === ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    GoDown() {
      this.$gtag.event("제안서다운_클릭", {
        event_category: "글로싸인엔터프라이즈",
        event_label: "제안서다운_클릭"
      });
      window.open("https://forms.gle/M9zDAXkM6bPqR3j89", "_blank");
    },
    userAgree() {
      this.$refs.userAgreement.open();
    },
    personInfo() {
      this.$refs.perInfoProtec.open();
    },
    goJoin() {
      this.$router.push({ name: "join" });
    },
    goPayment() {
      this.$router.push({ name: "paymentInfo" });
    },
    goMain() {
      this.$router.push({ name: "main" });
    }
  }
};
</script>
<style scoped>
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 100;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 300;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf)
      format("opentype");
}

#main.container {
  width: 100%;
  max-width: 100%;
}
input[type="text"],
input[type="email"],
input[type="number"],
button,
input[type="submit"],
input[type="reset"],
button,
input[type="tel"],
button,
input[type="password"],
input[type="url"],
input[type="search"],
input[type="file"],
button,
textarea {
  -webkit-appearance: none;
  appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  margin: 0;
  padding: 0;
  font-family: "NanumSquare", "Open Sans", sans-serif;
  border: none;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  background: none;
  font-size: 100%;
}
body {
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  position: relative;
  background: #fff;
  word-break: keep-all;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
input:focus,
button:focus {
  border: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
ul,
ol,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a:focus {
  outline: none !important;
}
a {
  text-decoration: none;
}
:invalid {
  box-shadow: none;
}
:-moz-submit-invalid {
  box-shadow: none;
}
:-moz-ui-invalid {
  box-shadow: none;
}
button::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin-top: -2px;
  margin-bottom: -2px;
}
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin-top: -2px;
  margin-bottom: -2px;
}
img {
  max-width: 100%;
}
button:hover {
  cursor: pointer;
}
button {
  background: transparent;
}
.just_contact_form {
  padding: 0px;
}
textarea:focus {
  outline: none;
}
:focus {
  outline: none;
}
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: scroll;
  font-size: 20px !important;
}
.mauto {
  margin: 0 auto;
}

/* ==== GRID SYSTEM ==== */

.container {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.row {
  position: relative;
  width: 100%;
}

.row [class^="col"] {
  padding: 0.5rem 2%;
  min-height: 0.125rem;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12 {
  width: 96%;
}

.col-1-sm {
  width: 4.33%;
}

.col-2-sm {
  width: 12.66%;
}

.col-3-sm {
  width: 21%;
}

.col-4-sm {
  width: 29.33%;
}

.col-5-sm {
  width: 37.66%;
}

.col-6-sm {
  width: 46%;
}

.col-7-sm {
  width: 54.33%;
}

.col-8-sm {
  width: 62.66%;
}

.col-9-sm {
  width: 71%;
}

.col-10-sm {
  width: 79.33%;
}

.col-11-sm {
  width: 87.66%;
}

.col-12-sm {
  width: 96%;
}
.hidden-sm {
  display: none;
}

@media only screen and (min-width: 33.75em) {
  /* 540px */
  .container {
    width: 80%;
  }
}

@media only screen and (min-width: 45em) {
  /* 45em 720px */
  .col-1 {
    width: 4.33%;
  }

  .col-2 {
    width: 12.66%;
  }

  .col-3 {
    width: 21%;
  }

  .col-4 {
    width: 29.33%;
  }

  .col-5 {
    width: 37.66%;
  }

  .col-6 {
    width: 46%;
  }

  .col-7 {
    width: 54.33%;
  }

  .col-8 {
    width: 62.66%;
  }

  .col-9 {
    width: 71%;
  }

  .col-10 {
    width: 79.33%;
  }

  .col-11 {
    width: 87.66%;
  }

  .col-12 {
    width: 96%;
  }

  .hidden-sm {
    display: block;
  }
}

@media only screen and (min-width: 60em) {
  /* 960px */
  .container {
    width: 75%;
    max-width: 60rem;
  }
}
/*main.css*/
.btn_top_bar00 {
  margin-right: 14px;
  padding: 0 24px 0 24px !important;
  width: auto;
  height: 36px !important;
  line-height: 36px !important;
  font-size: 0.75rem !important;
  border-radius: 18px;
}

/* common */
h2 {
  font-size: 56px;
  font-weight: 500;
  line-height: 1.35;
}
h3 {
  font-size: 42px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: -0.01em;
  margin-bottom: 80px;
}
h4 {
  font-size: 22px;
}
h5 {
  font-size: 18px;
}
.blind {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  margin: -1px;
  width: 1px;
  height: 1px;
}
.fl {
  display: block;
  float: left;
}
.fr {
  display: block;
  float: right;
}
.ofh {
  overflow: hidden;
}

@media screen and (max-width: 1023px) and (min-width: 1px) {
  h2 {
    font-size: 42px;
  }
  h3 {
    font-size: 32px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 719px) and (min-width: 1px) {
  h2 {
    font-size: 38px;
  }
  h3 {
    font-size: 24px;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 500px) and (min-width: 1px) {
  h2 {
    font-size: 30px;
  }
}

/* header */
#wrap {
  overflow: hidden;
}
.header {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  z-index: 10;
}
.header_wrap {
  margin: 0 auto;
  max-width: 1240px;
  height: 100%;
}
.header h1 {
  padding: 23px 40px 0 20px;
  float: left;
}
.logo_header {
  cursor: pointer;
  margin-top: 5px;
  display: block;
  width: 201px;
  height: 27px;
  background-image: url("../../assets/img/logo-w.svg");
  text-indent: -999999px;
}
.gnb {
  padding-top: 10px;
}
.header::after {
  display: block;
  content: "";
  clear: both;
}
.gnb .menu_main {
  float: right;
}
.gnb .menu_main li {
  position: relative;
  padding: 15px;
  float: left;
}
.gnb .menu_main li.menu a {
  font-size: 16px;
  color: #fff;
  line-height: 37px;
}
.gnb .menu_main li.menu :last-child {
  padding-right: 25px;
}
.header_link a {
  display: inline-block;
  padding: 4px 24px;
  font-size: 15px;
  color: #333;
  border: 1px solid #fff;
  border-radius: 20px;
  background: #fff;
}
.header_link a + a {
  margin-left: 10px;
}
.header_link :last-child {
  margin-right: 0;
}
.gnb .mobile_btn {
  float: right;
}
.gnb .mobile_btn .menu {
  display: none;
}
.menu_main .menu_btn {
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  line-height: 37px;
}

.header.st99 {
  transition: 0.3s ease-in-out;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
}
.header.st99 .logo_header {
  background-image: url("../../assets/img/logo.svg");
}
.header.st99 .gnb .menu_main li a,
.header.st99 .menu_main .menu_btn {
  color: #060c15;
}

.header.on {
  transition: 0.3s ease-in-out;
  background-color: #fff;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
}
.header.on .logo_header {
  background-image: url("../../assets/img/logo.svg");
}
.header.on .gnb .menu_main li a {
  color: #666;
}
.header.on .header_link a {
  border: 1px solid #999;
}
.header_overlay {
  display: none;
}

@media screen and (max-width: 960px) {
  .header.ov {
    background-color: #fff;
  }
  .header.ov .logo_header {
    background-image: url("../../assets/img/logo.svg");
  }
  .header .gnb .mobile_btn {
    padding: 0;
    padding-right: 10px;
    height: 1px;
  }
  .header .gnb .mobile_btn .menu {
    background: url("../../assets/img/baseline_menu.png");
  }
  .header .gnb {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .gnb .mobile_btn {
    float: none;
  }
  .gnb .mobile_btn .menu {
    margin-left: 10px;
    display: block;
    background: url("../../assets/img/baseline_menu_wh.png");
    width: 36px;
    height: 36px;
    text-indent: -9999px;
  }
  .gnb .mobile_btn .menu.off {
    background: url("../../assets/img/baseline_close.png");
  }
  .gnb .menu_main {
    display: none;
  }
  .gnb .menu_main.on {
    display: block;
    float: none;
    position: absolute;
    top: 60px;
    width: 100%;
    background: #fff;
    border-top: 1px solid #b5b8bb;
    border-bottom: 1px solid #b5b8bb;
    padding: 0 4%;
  }
  .gnb .menu_main.on li {
    display: block;
    float: none;
    position: relative;
    padding: 10px 20px;
    border-bottom: 1px solid #c3c3c3;
  }
  .gnb .menu_main.on li:last-child {
    border-bottom: 0;
  }
  .gnb .menu_main.on li.menu a {
    font-size: 16px;
    color: #000;
    line-height: 28px;
  }
  .header {
    height: 60px;
  }
  .header h1 {
    padding: 10px 0 0 20px;
    float: none;
  }
  .logo_header {
    margin: auto;
    margin-top: 10px;
  }
  .header_link {
    text-align: center;
    margin: 10px 0;
  }
  .header_link a {
    border: 1px solid #999;
  }
  .header_overlay.on {
    background: rgba(0, 0, 0, 0.5);
    display: block;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
  }
}

@media screen and (max-width: 374px) {
  .logo_header {
    height: 30px;
    background-size: 80%;
  }
}

/* content */
.main .content {
  margin: 0 auto;
  padding: 55px 0;
  max-width: 1240px;
  text-align: center;
}
.main .content h3 {
  padding-top: 70px;
}
/*.main .content h3 {background-image:url('../../assets/img/symbol.png');background-position:50% 0;background-repeat:no-repeat;color:#000;background-size:45px;}*/
.main .content h3 {
  padding-top: 50px;
  color: #000;
  background-size: 45px;
}

/* footer */
footer {
  padding: 30px 0 20px;
  background: #202224;
}
.footer {
  margin: 0 auto;
  max-width: 1240px;
  font-size: 14px;
  font-weight: 100;
  color: #dbdbdb;
}
.footer > .row {
  padding: 0 2%;
}
.fmenu_wrap {
  margin: 20px 2%;
  padding-top: 10px;
  border-top: 1px solid #4d4e50;
}
.fmenu_wrap::after {
  display: block;
  content: "";
  clear: both;
}
.fmenu_wrap .fmenu {
  float: left;
}
.fmenu_wrap .fmenu a {
  font-size: 16px;
  color: #a8a9a9;
}
.fmenu_wrap .fmenu li {
  float: left;
  margin-right: 40px;
}
.fmenu_wrap .fmenu::after {
  display: block;
  content: "";
  clear: both;
}
.fmenu_wrap .copy {
  float: right;
  color: #a8a9a9;
}

#floating {
  position: fixed;
  left: 0px;
  bottom: 100px;
  z-index: 10;
  display: inline-block;
  width: 160px;
  height: 68px;
  background: url("../../assets/img/btn_down.png") center top no-repeat;
}
#floating a {
  display: block;
  width: 160px;
  height: 68px;
  text-indent: -9999px;
}

@media screen and (max-width: 1279px) and (min-width: 1024px) {
}

@media screen and (max-width: 1023px) and (min-width: 1px) {
  .main .content {
    padding: 30px 20px;
  }
}

@media screen and (max-width: 782px) {
  .main .content {
    padding: 30px 30px;
  }
}

@media screen and (max-width: 719px) {
  #floating {
    width: 68px;
    bottom: 7vh;
    background: url("../../assets/img/btn_down_m.png") left center no-repeat;
  }
  #floating a {
    display: none;
  }
  .fmenu_wrap .fmenu {
    float: none;
    width: 100%;
    margin-bottom: 6px;
  }
  .fmenu_wrap .copy {
    float: none;
    width: 100%;
    font-size: 0.6rem;
  }
  .footer {
    padding: 10px 0;
  }
  .row [class^="col"]:not(.nopd) {
    padding: 4px 2%;
  }
  .fmenu_wrap {
    margin: 10px 4%;
  }
  .fmenu_wrap .fmenu a {
    font-size: 0.7rem;
  }
}

@media screen and (max-width: 318px) and (min-width: 1px) {
  body {
    min-width: 320px;
  }
}

/* 요금제 */
.section_pay {
}
.section_pay .content {
  padding: 150px 0 100px;
}
.section_pay h3 {
  margin-bottom: 50px;
}
.section_pay .tit {
  font-size: 30px;
  color: #7ca0f6;
}
.section_pay .ct {
  font-size: 16px;
  color: #b5b8bb;
  padding-bottom: 50px;
}
.section_pay .txt {
  display: inline;
  position: relative;
  margin-top: 50px;
  padding-left: 27px;
  font-size: 20px;
  line-height: 1.35;
}
/* .section_pay .txt span.chk{display:inline-block;width:20px;height:23px;padding-top:3px;margin-right:10px;background:url('../../assets/img/main/bul_check.png') 0 3px no-repeat;} */
.section_pay .txt .before {
  display: inline-block;
  content: "";
  position: absolute;
  top: 4px;
  left: 0;
  width: 20px;
  height: 20px;
  background-image: url("../../assets/img/bul_check.png");
  background-repeat: no-repeat;
}
.section_pay .txt2 {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  color: #b5b8bb;
}
.mb50 {
  margin-bottom: 50px;
}

.row [class^="box"] {
  float: left;
  margin: 0.5rem 2%;
  min-height: 0.125rem;
}

.box1,
.box2,
.box3,
.box4,
.box5 {
  width: 16%;
}

.tbl_pay {
  border-top: 3px solid #94b4f8;
  box-shadow: 1px 8px 10px rgba(0, 0, 0, 0.1);
}
.tbl_pay {
  padding: 25px 0 50px;
}
.tbl_pay span {
  display: inline-block;
  padding: 0 10px;
  background-color: #9da09f;
  font-size: 17px;
  font-weight: 300;
  color: #fff;
  border-radius: 4px;
}
.tbl_pay strong {
  display: block;
  font-size: 30px;
  font-weight: 400;
  color: #000;
}
.tbl_pay p {
  color: #adb0b3;
}
.tbl_pay .sale {
  padding-top: 20px;
  color: #ff7666;
  font-size: 18px;
}

.section_pay .pay_btn {
  display: inline-block;
  margin-top: 50px;
  padding: 15px 60px;
  background-color: #31c964;
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  border-radius: 10px;
}

@media only screen and (max-width: 1023px) {
  .section_pay .content {
    padding: 130px 20px 50px 20px;
  }
  .tbl_pay {
    padding: 25px 0 30px;
  }
  .section_pay .tit {
    font-size: 26px;
  }
  .box1,
  .box2,
  .box3,
  .box4,
  .box5 {
    width: 46%;
  }
}

@media only screen and (max-width: 500px) {
  .section_pay .content {
    padding: 130px 30px 50px 30px;
  }
  .section_pay .tit {
    font-size: 22px;
  }
  .box1,
  .box2,
  .box3,
  .box4,
  .box5 {
    width: 96%;
  }
  .box1.tbl_pay .sale {
    display: none;
  }
  .tbl_pay span {
    font-size: 14px;
  }
  .tbl_pay strong {
    font-size: 24px;
  }
  .tbl_pay .sale {
    padding-top: 10px;
    font-size: 16px;
  }
}
</style>
